// src/stone/illustrations/StonjiLockIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiLockIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 81 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M.25 0h80v80h-80z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M55.275 35h-30.05a4.977 4.977 0 0 0-4.977 4.978v25.046A4.977 4.977 0 0 0 25.225 70h30.05a4.977 4.977 0 0 0 4.977-4.977V39.978A4.977 4.977 0 0 0 55.275 35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M50.25 20.002a10.004 10.004 0 1 0-20.003 0v14.999h4.99V20.002a5.01 5.01 0 0 1 5.01-5.161 5.01 5.01 0 0 1 5.011 5.161v14.999h4.991z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M25.247 45a5 5 0 1 0 0-10 5 5 0 0 0 0 10M55.249 45a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40.294 15.003a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004M32.749 27.5a2.502 2.502 0 1 0 0-5.005 2.502 2.502 0 0 0 0 5.004M47.747 27.5a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.003M40.246 54.998a5 5 0 1 0 0-9.998 5 5 0 0 0 0 9.998"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40.246 60.002a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40.246 54.998a2.502 2.502 0 1 0 0-5.003 2.502 2.502 0 0 0 0 5.003"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M42.748 52.497h-5v5.132h5z" })
    ]
  }
);
var StonjiLockIllustration_default = StonjiLockIllustration;

export {
  StonjiLockIllustration_default
};
